<div *ngIf="taskOptionsService.selectedBoard">
    <div class="types_menu list-group">
        <a (click)="onOpenModal(createTypeView)" class="list-group-item list-group-item-action" data-action='createType'
           style="background: lightgrey">
            <i class="bi bi-journal-plus" style="margin-right: 5px; font-size: 20px"></i>
            {{ 'TASKS.SETTINGS.TEXT.ADD_TASK_TYPE' | translate }}
        </a>
    </div>
    <div class="types_menu list-group">
        <a *ngFor="let type of taskOptionsService.selectedBoard.task_types; let i = index"
           class="list-group-item list-group-item-action"
           style="padding: 0 1.25rem">
            <div [attr.index]="i" class="type">
                <div (click)="selectType = type; onOpenModal(changeTypeView)" class="typeName"
                     data-action='settingsType'>
                    <i class="{{type.icon}} typeIcon"></i>
                    <span>{{ type.name }}</span>
                </div>
                <i (click)="onOpenDeleteModal(type, deleteTypeView)" class="bi bi-journal-x deleteType"
                   data-action='deleteType'
                   title="{{ 'BUTTON_TEXT.DELETE' | translate }}"></i>
            </div>
        </a>
    </div>
</div>

<ng-template #createTypeView let-modal>
    <app-button-modal-close (closeEmit)="svgIcons.selectedSvg = null" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1 style="margin-bottom: 15px;">{{ 'MODALS.HEADERS.CREATE_TASK_TYPE' | translate }}</h1>

        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #typeName aria-describedby="emailHelp" class="form-control" name="folderName" required>

        <div style="margin-top: 10px;">
            <h2>{{ 'MODALS.FIELDS.ICON' | translate }}: </h2>
            <i (click)="isShowIcons = !isShowIcons" *ngIf="svgIcons.selectedSvg"
               class="{{svgIcons.selectedSvg}}" style="cursor: pointer; font-size: 3em;"></i>

            <i (click)="svgIcons.selectedSvg = ''" *ngIf="svgIcons.selectedSvg" class="bi bi-trash"
               style="color: red; cursor: pointer; margin-left: 10px;"></i>
            <i (click)="isShowIcons = !isShowIcons" *ngIf="!svgIcons.selectedSvg" style="cursor: pointer;">
                {{ 'MODALS.FIELDS.SELECT.ICON_NOT_SELECTED' | translate }}
            </i>
            <div *ngIf="isShowIcons" class="iconsTable">
                <i (click)="svgIcons.selectedSvg = icon; isShowIcons = false"
                   *ngFor="let icon of svgIcons.allSvg"
                   class="{{icon}}"
                   style="margin: 5px; font-size: 32px; cursor: pointer">
                </i>
            </div>
        </div>
        <button (click)="createTaskType(typeName.value, modal)" [disabled]="isLockButton"
                class="btn btn-block btn-success"
                data-action='createTypeButton'
                style="margin-top: 10px;">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>


<ng-template #changeTypeView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1 style="margin-bottom: 15px;">{{ 'MODALS.HEADERS.EDIT_TASK_TYPE' | translate }}</h1>

        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}:
            <input #typeName
                   (change)="selectType.name = typeName.value"
                   [value]="selectType.name"
                   class="form-control"
                   type="text"
            >
        </h2>

        <div>
            <h2>{{ 'MODALS.FIELDS.ICON' | translate }}: </h2>
            <i (click)="isShowIcons = !isShowIcons" *ngIf="selectType.icon" class="{{selectType.icon}}"
               style="cursor: pointer; font-size: 3em;"></i>

            <i (click)="selectType.icon = ''" *ngIf="selectType.icon" class="bi bi-trash"
               style="color: red; cursor: pointer; margin-left: 10px;"></i>
            <i (click)="isShowIcons = !isShowIcons" *ngIf="!selectType.icon" style="cursor: pointer;">
                {{ 'MODALS.FIELDS.SELECT.ICON_NOT_SELECTED' | translate }}
            </i>
            <div *ngIf="isShowIcons" class="iconsTable">
                <i (click)="selectType.icon = icon; isShowIcons = false"
                   *ngFor="let icon of svgIcons.allSvg"
                   class="{{icon}}"
                   style="margin: 5px; font-size: 32px; cursor: pointer">
                </i>
            </div>
        </div>
        <button (click)="updateTaskType(modal)" [disabled]="isLockButton" class="btn btn-block btn-success"
                data-action='saveSettingsType'
                style="margin-top: 15px;">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.SAVE' | translate }}</span>
        </button>
    </div>
</ng-template>


<ng-template #deleteTypeView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1 style="margin-bottom: 15px;">{{ 'MODALS.HEADERS.CONFIRM_DELETE' | translate }} {{ selectedType.name }}?</h1>

        <h2>{{ 'MODALS.TEXT.DELETE_TASK_TYPE' | translate }}</h2>

        <select #type class="form-select">
            <option hidden value="">{{ 'MODALS.FIELDS.SELECT.SELECT_TASK_TYPE' | translate }}</option>
            <option *ngIf="!boardTypes.length" disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}</option>
            <option *ngFor="let item of boardTypes" value="{{item.id}}">{{ item.name }}</option>
        </select>

        <button (click)="deleteTaskType(type.value, modal)" [disabled]="isLockButton" class="btn btn-block btn-success"
                data-action='deleteTypeButton'
                style="margin-top: 15px;">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.DELETE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
